export default {
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  RESET_USER_SETTINGS: 'RESET_USER_SETTINGS'
};